import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Icon, Loader, Text } from "monday-ui-react-core";
import MainService from '../services/MainService';
import { Tooltip } from 'react-tooltip';
import UrlConsts from '../constants/UrlConstants';

const FormMandatory: React.FC = () => {
  const [context, setContext] = useState<any>(null);
  const [saving, setSaving] = useState<boolean>(false);
  const [boardId, setBoardId] = useState<number>();
  const [accountId, setAccountId] = useState<number>();
  const [boardColumns, setBoardColumns] = useState<any>();
  const [loadingColumn, setLoadingColumn] = useState<boolean>(true);
  const [boardGroups, setBoardGroups] = useState<any>();
  const [requiredList, setRequiredList] = useState<any>([]);
  // const [refreshForm, setRefreshForm] = useState<boolean>(false);
  // const [columnHorizontal, setColumnHorizontal] = useState<boolean>(false);
  const [originColumns, setOriginColumns] = useState<any>();
  const [originGroups, setOriginGroups] = useState<any>();
  const [copied, setCopied] = useState<any>();
  const [copiedId, setCopiedId] = useState<any>();
  const [viewMode, setViewMode] = useState<any>();

  enum IconType {
    SVG = "SVG",
    ICON_FONT = "FA",
    SRC = "SRC"
  }
  useEffect(() => {
    async function fetchData() {
      try {
        // await setColumnHorizontal(false);
        await setViewMode(false);
        const tmpContext = await MainService.getContext();
        await setContext(tmpContext);
        await setBoardId(tmpContext?.boardId);
        await setAccountId(tmpContext?.account?.id);
      } catch (error) {
        console.log(error);
      }
    }

    fetchData(); // Call the function to fetch data when component mounts
  }, []);

  useEffect(() => {
    if (context) {
      const init = async () => {
        const columns = await MainService.getColumns(context?.boardId);
        await setOriginColumns(columns);
        const _boardColumns = MainService.fillBoardColumn(columns);
        let _group = await MainService.getGroup(context?.boardId);
        await setOriginGroups(_group ?? []);
        const requiredByGroup = await MainService.getGroupRequired(context?.account?.id, context?.boardId);
        await setRequiredList(requiredByGroup?.data?.length ? requiredByGroup?.data : []);
        const data = await MainService.postNoAuthen({
          accountId: context?.account?.id,
          boardId: context?.boardId
        }, UrlConsts.checkAuthenType);
        await setViewMode(data?.data?.viewMode);
        await setBoardColumns(!data?.data?.viewMode ? _boardColumns ?? [] : _group ?? []);
        await setBoardGroups(!data?.data?.viewMode ? _group ?? [] : _boardColumns ?? []);
        await setLoadingColumn(false);
        await setCopiedId(null);
        await setCopied(null);
      }
      init();
    }
  }, [context]);

  const handleSave = async () => {
    setSaving(true);
    MainService.notice('Saving...', 'info');

    const data = {
      account_id: accountId,
      board_id: boardId,
      required: requiredList,
      monday_url: await MainService.getMondayUrl()
    }
    const rs = await MainService.post(data, UrlConsts.createUpdateRequired);
    if (rs) {
      MainService.notice('Save success');
    } else {
      MainService.notice('Something went wrong...', 'error');
    }

    setSaving(false);
  }

  const handleCheckboxChange = async (groupId, columnId, groupTitle, columnTitle) => {
    const upd = [...requiredList];

    const required = upd?.findIndex(s => s.group_id === groupId && s.column_id === columnId);
    if (required >= 0) {
      upd.splice(required, 1);
    } else {
      upd.push({
        group_id: groupId,
        column_id: columnId,
        group_name: groupTitle,
        column_name: columnTitle
      });
    }
    await setRequiredList(upd);
  }
  // const handleRefresh = () => {
  //   setRefreshForm(!refreshForm);
  //   setLoadingColumn(true);
  // }

  // const handleSwitchView = async () => {
  //   const horizontal = !viewMode;
  //   await setLoadingColumn(true);
  //   const _boardColumns = MainService.fillBoardColumn(originColumns);
  //   if (horizontal) {
  //     const _groups = [...originGroups];
  //     await setBoardColumns(_groups ?? []);
  //     await setBoardGroups(_boardColumns ?? []);
  //   } else {
  //     await setBoardColumns(_boardColumns ?? []);
  //     await setBoardGroups(originGroups ?? []);
  //   }

  //   await setCopied(null);
  //   await setCopiedId(null);
  //   await setLoadingColumn(false);
  //   // await setColumnHorizontal(!columnHorizontal);
  // }

  const handleCopy = async (id, type) => {
    let upd = [...requiredList];
    if (type === 1) {
      let tmp = upd?.filter(s => (viewMode ? s.column_id === id : s.group_id === id));
      tmp = tmp?.length ? tmp : [{ group_id: id, column_id: id }];
      const required = tmp?.map(s => { return (viewMode ? s.group_id : s.column_id) });
      await setCopiedId(viewMode ? tmp?.[0]?.column_id : tmp?.[0]?.group_id);
      if (required) {
        await setCopied(required);
        MainService.notice(`Copied`);
      }
    }

    if (type === 2) {
      // let updateRequired = upd?.filter(s => (!viewMode ? s.column_id !== id : s.group_id !== id));
      upd = upd?.filter(s => (viewMode ? s.column_id !== id : s.group_id !== id));
      copied.forEach(copy => {
        upd.push({
          group_id: viewMode ? copy : id,
          column_id: viewMode ? id : copy,
          group_name: originGroups?.find(s => s.id === (viewMode ? copy : id))?.title,
          column_name: originColumns?.find(s => s.id === (viewMode ? id : copy))?.title
        });
      });
      await setRequiredList(upd);
      MainService.notice('Paste');
    }
  }

  return (
    <>
      <div className="mb-5">
        {/* <Button onClick={handleSwitchView} className='mr-6' disabled={saving || loadingColumn}>Switch View <i className="ml-1 fa-solid fa-right-left"></i></Button> */}
        {/* <Button className='mr-6 text-center' onClick={handleRefresh} rightIcon={'TurnInto'} disabled={saving || loadingColumn}>Refresh <i className="ml-1 fa-solid fa-rotate"></i></Button> */}
      </div>
      {loadingColumn && (
        <div className="inline-block mt-16 mx-auto">
          <Loader
            className="custom-loader-form"
            hasBackground={true}
            size={64}
          />
        </div>
      )}
      {!loadingColumn && (
        <>
          <div className="container mx-auto relative w-11/12">
            <div className="overflow-auto max-h-500">
              <div className="grid">
                {/* header */}
                <div
                  className={`sticky top-0 z-20 grid ${
                    context.theme === "light"
                      ? "bg-gray-50"
                      : context.theme === "dark"
                      ? "bg-dark-theme"
                      : "bg-gray-900"
                  }`}
                  style={{
                    gridTemplateColumns: `repeat(${
                      boardColumns.length + 1
                    }, 1fr)`,
                  }}
                >
                  <div
                    className={`border sticky top-0 left-0 z-30 min-w-48 font-bold flex flex-col items-center ${
                      context.theme === "light"
                        ? "bg-gray-200"
                        : context.theme === "dark"
                        ? "bg-dark-theme"
                        : "bg-gray-900"
                    }`}
                  >
                    <span
                      className="absolute inset-0"
                      style={{
                        background:
                          "linear-gradient(to left bottom, transparent calc(49% - 1px), gray calc(50% - 1px), gray 10%, transparent calc(50% + 1px))",
                      }}
                    ></span>
                    <div className="px-3">
                      <Text
                        className="absolute top-1 right-2 font-bold"
                        color={Text.colors.PRIMARY}
                        type={Text.types.TEXT2}
                      >
                        {viewMode ? "Groups" : "Columns"}
                      </Text>
                      <Text
                        className="absolute bottom-1 left-2 font-bold"
                        color={Text.colors.PRIMARY}
                        type={Text.types.TEXT2}
                      >
                        {viewMode ? "Columns" : "Groups"}
                      </Text>
                    </div>
                  </div>
                  {boardColumns?.map((f, i) => (
                    <div key={f.id} className={`border min-w-36`}>
                      <Text
                        color={Text.colors.PRIMARY}
                        type={Text.types.TEXT2}
                        className="text-center p-4"
                      >
                        {f.title}
                      </Text>
                    </div>
                  ))}
                </div>
                {/* End header */}
                {/* body */}
                {boardGroups.map((group, i) => (
                  <div
                    className={`body-hover grid`}
                    style={{
                      gridTemplateColumns: `repeat(${
                        boardColumns.length + 1
                      }, 1fr)`,
                    }}
                  >
                    <Tooltip
                      key={"Tooltipcopy1" + group.id}
                      anchorSelect=".tt-copy"
                      place="left"
                      className="z-50"
                    >
                      Copy
                    </Tooltip>
                    <Tooltip
                      key={"tooltoppaste" + group.id}
                      anchorSelect=".tt-paste"
                      place="left"
                      className="z-50"
                    >
                      Paste
                    </Tooltip>
                    <div
                      className={`border z-10 min-w-48 sticky left-0 h-full content-center align-middle items-center flex justify-start ${
                        context.theme === "light"
                          ? "bg-gray-50"
                          : context.theme === "dark"
                          ? "bg-dark-theme"
                          : "bg-gray-900"
                      }`}
                    >
                      <div className="copy-container mt-2 mb-2">
                        <div className="mb-1 ml-1">
                          <Button
                            key={"buttoncopy" + group.id}
                            onClick={() => handleCopy(group.id, 1)}
                            disabled={copiedId === group.id}
                            className="tt-copy"
                            size="xs"
                          >
                            <Icon
                              key={"iconcopy" + group.id}
                              iconType={IconType.ICON_FONT}
                              icon="fa-regular fa-copy"
                            ></Icon>
                          </Button>
                        </div>
                        <div className="ml-1">
                          <Button
                            key={"buttonpaste" + group.id}
                            onClick={() => handleCopy(group.id, 2)}
                            disabled={copiedId === group.id || !copied}
                            size="xs"
                            className={`tt-paste ${
                              copiedId !== group.id && copied
                                ? "!bg-gray-400"
                                : ""
                            }`}
                          >
                            <Icon
                              key={"iconpaste" + group.id}
                              iconType={IconType.ICON_FONT}
                              icon="fa-regular fa-paste"
                            ></Icon>
                          </Button>
                        </div>
                      </div>
                      <Text
                        className="pl-2"
                        color={Text.colors.PRIMARY}
                        type={Text.types.TEXT2}
                      >
                        {group.title}
                      </Text>
                    </div>
                    {boardColumns.map(
                      (column) =>
                        column.id !== -1 && (
                          <div key={column.id} className={`border min-w-36`}>
                            <Checkbox
                              className="text-center p-4 mx-auto"
                              checked={
                                viewMode
                                  ? requiredList?.some(
                                      (s) =>
                                        s.group_id === column.id &&
                                        s.column_id === group.id
                                    )
                                  : requiredList?.some(
                                      (s) =>
                                        s.group_id === group.id &&
                                        s.column_id === column.id
                                    )
                              }
                              onChange={() =>
                                handleCheckboxChange(
                                  viewMode ? column.id : group.id,
                                  viewMode ? group.id : column.id,
                                  viewMode ? column.title : group.title,
                                  viewMode ? group.title : column.title
                                )
                              }
                              name={`ckb_${group.id}_${column.id}`}
                              disabled={saving}
                            />
                          </div>
                        )
                    )}
                  </div>
                ))}
                {/* End body */}
              </div>
            </div>
          </div>

          <div className="mt-4 text-center mb-16">
            <Button
              className="mr-10"
              onClick={handleSave}
              loading={saving}
              disabled={loadingColumn}
            >
              Save
            </Button>
          </div>
        </>
      )}
    </>
  );
};

export default FormMandatory;
